/**
 * file-processing-interface.js
 * ファイル処理系APIのI/F定義
 * ファイルのダウンロードやインポート、エクスポートなどのリクエスト用インターフェースを定義する
 */

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

/**
 * ファイル処理系APIのI/F定義クラス
 */
export default class FileProcessingInterface {

  /**
   * コンストラクター
   */
  constructor () {
    // ペイロード要素
    this.PAYLOAD_ITEM = {
      // 処理種別
      EXECUTE_TYPE: 'execute-type',
      // ファイル種別
      FILE_TYPE: 'file-type',
      // データ
      DATA: 'data'
    }
    // 処理種別
    this.EXECUTE_TYPE = {
      // 媒体連携項目マスター
      RECRUITMENT_MEDIA_ITEM_MASTER: 'recruitment-media-item-master',
    }
    // ファイル種別
    this.FILE_TYPE = {
      // CSVテンプレートファイル
      TEMPLATE_CSV: 'template-csv',
      // CSVエクスポート
      EXPORT_CSV: 'export-csv',
      // CSVインポート
      IMPORT_CSV: 'import-csv',
      // Excelテンプレートファイル
      TEMPLATE_EXCEL: 'template-excel',
      // Excelエクスポート
      EXPORT_EXCEL: 'export-excel',
      // Excelインポート
      IMPORT_EXCEL: 'import-excel',
    }
    // ペイロード初期値
    this.payload = {
      // 処理種別
      [this.PAYLOAD_ITEM.EXECUTE_TYPE]: '',
      // ファイルタイプ
      [this.PAYLOAD_ITEM.FILE_TYPE]: '',
      // データ
      [this.PAYLOAD_ITEM.DATA]: {}
    }
  }

  /**
   * 媒体連携項目マスターCSVテンプレートダウンロードペイロード作成
   * @param {Object} masterTemplate テンプレートデータ
   * @return {Object} ペイロード
   */
  makeItemMasterCsvTemplateDownloadPayload (currentMaster, masterName) {
    try {
      // 処理種別：媒体連携項目マスター
      this.payload[this.PAYLOAD_ITEM.EXECUTE_TYPE] = this.EXECUTE_TYPE.RECRUITMENT_MEDIA_ITEM_MASTER
      // ファイル種別：CSVテンプレートファイル
      this.payload[this.PAYLOAD_ITEM.FILE_TYPE] = this.FILE_TYPE.TEMPLATE_CSV
      // リクエストデータ：媒体連携項目マスターテンプレートデータ
      this.payload[this.PAYLOAD_ITEM.DATA] = currentMaster
      this.payload[this.PAYLOAD_ITEM.DATA]['master_name'] = masterName
      // ペイロードを返す
      return this.payload
    } catch (error) {
      throw error
    }
  }

  /**
   * 媒体連携項目マスターデータCSVエクスポートクエリパラメータ作成
   * @param {Number} masterId 媒体連携項目マスターID
   * @return {String} クエリパラメーター
   */
  makeItemMasterDataExportParameter (masterId) {
    try {
      let queryParameter = ''
      // クエリパラメーターを作成
      queryParameter = '{0}={1}&{2}={3}&master-id={4}'.format(
        // 処理種別
        this.PAYLOAD_ITEM.EXECUTE_TYPE,
        // 媒体連携項目マスター
        this.EXECUTE_TYPE.RECRUITMENT_MEDIA_ITEM_MASTER,
        // ファイル種別
        this.PAYLOAD_ITEM.FILE_TYPE,
        // CSVエクスポート
        this.FILE_TYPE.EXPORT_CSV,
        // 媒体連携項目マスターID
        masterId
      )
      // クエリパラメーターを返す
      return queryParameter
    } catch (error) {
      throw error
    }
  }

  /**
   * 媒体連携項目マスターデータCSVインポートペイロード作成
   * @param {Object} importFile インポートファイル
   * @return {Object} ペイロード
   */
  makeItemMasterDataImportPayload (importFile) {
    try {
      let payload = new FormData()
      // 処理種別：媒体連携項目マスター
      payload.append(this.PAYLOAD_ITEM.EXECUTE_TYPE, this.EXECUTE_TYPE.RECRUITMENT_MEDIA_ITEM_MASTER)
      // ファイル種別：CSVインポート
      payload.append(this.PAYLOAD_ITEM.FILE_TYPE, this.FILE_TYPE.IMPORT_CSV)
      // リクエストデータ：媒体連携項目マスターインポートファイル
      payload.append(this.PAYLOAD_ITEM.DATA, importFile)

      // ペイロードを返す
      return payload
    } catch (error) {
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/general-purpuse/file-processing-interface.js